import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './ProjectRepAssigned.scss';
import { putRequest } from '../../requestUtils';
var ProjectRepAssigned = /*#__PURE__*/function (_Component) {
  function ProjectRepAssigned(props) {
    var _this;
    _classCallCheck(this, ProjectRepAssigned);
    _this = _callSuper(this, ProjectRepAssigned, [props]);
    _this.state = {
      assignedRep: props.assignedRep
    };
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    _this.handleAssignRep = _this.handleAssignRep.bind(_this);
    _this.handleDefaultAssignedRep = _this.handleDefaultAssignedRep.bind(_this);
    return _this;
  }
  _inherits(ProjectRepAssigned, _Component);
  return _createClass(ProjectRepAssigned, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleDefaultAssignedRep();
    }
  }, {
    key: "handleAssignRep",
    value: function handleAssignRep() {
      var _this2 = this;
      var assignedRep = this.state.assignedRep;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        project = _this$props.project;
      putRequest("/projects/".concat(project.resource_id, "/"), {
        assigned_rep_id: assignedRep.value
      }, csrfToken)["catch"](function () {
        _this2.setState({
          assignedRep: {}
        });
      });
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(assignedRep) {
      this.setState({
        assignedRep: assignedRep
      }, this.handleAssignRep);
    }
  }, {
    key: "handleDefaultAssignedRep",
    value: function handleDefaultAssignedRep() {
      var assignedRep = this.props.assignedRep;
      var defaultRep = assignedRep ? {
        value: assignedRep.id,
        label: assignedRep.name
      } : {};
      this.setState({
        assignedRep: defaultRep
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var reps = this.props.reps;
      var assignedRep = this.state.assignedRep;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "rep-assign form-group mb-8"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "project"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight"
      }, "Clora rep for project")), /*#__PURE__*/React.createElement(Select, {
        id: "clora rep",
        className: "body-text-2",
        classNamePrefix: "select-clora-rep",
        placeholder: "Select or type...",
        options: reps.map(function (rep) {
          return {
            value: rep.id,
            label: rep.name
          };
        }),
        value: assignedRep,
        onChange: function onChange(option) {
          _this3.handleSelectChange(option);
        }
      })));
    }
  }]);
}(Component);
ProjectRepAssigned.propTypes = {
  reps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  assignedRep: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  project: PropTypes.shape({})
};
ProjectRepAssigned.defaultProps = {
  project: null,
  assignedRep: {}
};
export default ProjectRepAssigned;